import styled from 'styled-components'

const EditorContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
`

const MainLayout = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const LeftPanel = styled.div<{ $collapsed?: boolean }>`
  width: ${props => (props.$collapsed ? '50px' : '300px')};
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
  overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`

const CenterPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fafbfc;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`

const RightPanel = styled.div<{ $collapsed?: boolean }>`
  width: ${props => (props.$collapsed ? '50px' : '300px')};
  background: white;
  border-left: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    flex: 1;
    overflow-y: auto;
  }
`

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #666;
`

const MobileNotice = styled.div`
  display: none;
  padding: 1rem;
  background: #fff3cd;
  color: #856404;
  border-bottom: 1px solid #ffc107;
  text-align: center;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    display: block;
  }
`

const ToggleButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 60px;
  background: white;
  border: 1px solid #e1e5e9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  padding: 0;
  transition: all 0.2s ease;

  &:hover {
    background: #f6f8fa;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const LeftToggleButton = styled(ToggleButton)`
  right: -10px;
  border-radius: 0 4px 4px 0;
  border-left: none;
`

const RightToggleButton = styled(ToggleButton)`
  left: -10px;
  border-radius: 4px 0 0 4px;
  border-right: none;
`

const PanelContent = styled.div<{ $collapsed?: boolean }>`
  opacity: ${props => (props.$collapsed ? 0 : 1)};
  visibility: ${props => (props.$collapsed ? 'hidden' : 'visible')};
  transition: opacity 0.2s ease, visibility 0.2s ease;
  width: 300px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Ensure child components handle their own scrolling */
`

const PanelSwitcher = styled.div`
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  height: 40px;
`

const SwitchButton = styled.button<{ $active: boolean }>`
  flex: 1;
  background: ${({ $active }) => $active ? 'white' : 'transparent'};
  border: none;
  border-bottom: ${({ $active }) => $active ? '2px solid #007bff' : 'none'};
  padding: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: ${({ $active }) => $active ? '600' : '400'};
  color: ${({ $active }) => $active ? '#007bff' : '#666'};
  transition: all 0.2s;

  &:hover {
    background: ${({ $active }) => $active ? 'white' : '#f8f9fa'};
  }
`

const PanelContentArea = styled.div`
  flex: 1;
  overflow: hidden;
`

export {
  EditorContainer,
  MainLayout,
  LeftPanel,
  CenterPanel,
  RightPanel,
  LoadingContainer,
  MobileNotice,
  LeftToggleButton,
  RightToggleButton,
  PanelContent,
  PanelSwitcher,
  SwitchButton,
  PanelContentArea,
}
